import React from 'react';
import { bool, string } from 'prop-types';
import { useSelector } from 'react-redux';
import styles from './styles/styles.module.scss';
import River from '../../../../components/shared/River';
import { DESKTOP_BREAKPOINT } from '../../../../utils/constants/breakpoints';

const INITIAL_SLICK_SETTINGS = {
  centerMode: true,
  slidesToShow: 1,
  centerPadding: '0px',
  variableWidth: true,
  useTransform: false
};
const ARROW_STYLES = { next: styles.next, previous: styles.previous };

// This component will continue to grow as we support trail cards in carousels in feeds
const FeedRiver = ({ children, lazyLoad, childClassName, centerMode }) => {
  const { windowWidth } = useSelector(state => state.browserWindow);

  const { slickSettings, useSlick } = {
    slickSettings: { ...INITIAL_SLICK_SETTINGS, lazyLoad, centerMode },
    useSlick: windowWidth > DESKTOP_BREAKPOINT
  };

  const getFirstChildClass = idx => {
    if (idx === 0 && centerMode) {
      return styles.firstChildCenterMode;
    }

    if (idx === 0) {
      return styles.firstChild;
    }

    return '';
  };

  return (
    <River useSlick={useSlick} slickSettings={slickSettings} className={styles.riverClass} arrowStyles={ARROW_STYLES}>
      {children.map((child, idx) => (
        <div className={`${styles.riverContainer} ${childClassName} ${getFirstChildClass(idx)}`}>{child}</div>
      ))}
    </River>
  );
};

FeedRiver.propTypes = {
  lazyLoad: bool,
  centerMode: bool,
  childClassName: string
};

FeedRiver.defaultProps = {
  lazyLoad: false,
  childClassName: '',
  centerMode: true
};

export default FeedRiver;
